import { createContext } from '@fluentui/react-context-selector';
import { ICardContext } from '../../types';

export const CardContext = createContext<ICardContext>({} as ICardContext);
